// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"Switch_switchContainer__3aP5C","disabled":"Switch_disabled__1pNd8","switchIcon":"Switch_switchIcon__148B5","pip":"Switch_pip__1AAIT"};